export const COLORS = {
  primary: "#007aff",
  subtleText: "#6b7280",
  cardBg: "#ffffff",
  pageBg: "rgb(235 249 255)",
  lawyer: "#167ec4ff",
  client: "#1ab394",
  lawyerBg: "#eaf4ff",
  clientBg: "#e9fbf1",
};

export const STYLES = {
  pill: {
    padding: "6px 14px",
    color: "white",
    borderRadius: "10px",
    fontWeight: 700,
    fontSize: 14,
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
  },
  sectionCard: {
    background: COLORS.cardBg,
    borderRadius: "10px",
    padding: "10px",
    boxShadow: "0 6px 18px rgba(20,20,30,0.06)",
    border: "1px solid rgba(0,0,0,0.04)",
    display: "flex",
    alignItems: "center",
  },
  avatarWrapper: {
    background: "#fff",
    width: 90,
    height: 90,
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
  },
  autoWrapper: {
    display: "flex",
    gap: 0.5,
    alignItems: "center",
    background: "#f7f9fc",
    padding: "4px 6px",
    borderRadius: "10px",
    border: "1px solid rgba(0,0,0,0.06)",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
  },
};
